import styled from "styled-components";
import {
  ActivityIndicator,
  Button,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Image
} from "react-native";
import * as React from "react";
import { useState } from "react";
import * as firebase from "firebase/app";
import { useRouter } from "../utils/router";

const Container = styled(View)`
  flex: 1;
  align-items: center;
  justify-content: center;
  background-color: #dddddd;
`;

const SignIn = (props: { loading?: boolean; onPress: () => void }) => (
  <SignIn.Container onPress={props.onPress}>
    {props.loading ? (
      <ActivityIndicator />
    ) : (
      <SignIn.Text>Sign in with Google</SignIn.Text>
    )}
  </SignIn.Container>
);

SignIn.Text = styled(Text)`
  font-size: 15px;
  font-weight: 600;
`;

const InputBox = styled(TextInput).attrs({
  placeholder: "Admin Password"
})`
  height: 50px;
  width: 280px;
  padding: 0 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  elevation: 3;
  margin-bottom: 20px;
  background-color: white;
  border-radius: 10px;
`;

SignIn.Container = styled(TouchableOpacity)`
  height: 50px;
  width: 220px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  elevation: 3;
  flex-direction: row;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
`;

const PermissionText = styled(Text)`
  color: gray;
  margin-bottom: 20px;
  font-size: 17px;
`;

const LoginScreen = () => {
  const [loading, setLoading] = useState(false);
  const { history } = useRouter();
  const [status, setStatus] = useState<"signIn" | "pending_promote">("signIn");
  const [password, setPassword] = useState("");
  return (
    <Container>
      {status === "signIn" ? (
        <SignIn
          loading={loading}
          onPress={async () => {
            try {
              setLoading(true);
              const { user } = await firebase
                .auth()
                .signInWithPopup(new firebase.auth.GoogleAuthProvider());
              if (!user) {
                throw new Error("User not found");
              }
              const result = await user.getIdTokenResult();
              if (result.claims.isAdmin) {
                setLoading(false);
                history.replace("/");
                return;
              } else {
                setLoading(false);
                setStatus("pending_promote");
              }
            } catch (e) {
              alert(e.message);
              setLoading(false);
            }
          }}
        />
      ) : (
        <>
          <PermissionText>You are not a site admin!</PermissionText>
          <InputBox
            secureTextEntry={true}
            value={password}
            onChangeText={setPassword}
          />
          {loading ? (
            <ActivityIndicator />
          ) : (
            <Button
              disabled={password.length === 0}
              title="Promote to admin"
              onPress={async () => {
                try {
                  setLoading(true);
                  await firebase.functions().httpsCallable("siteAdmin-promote")(
                    {
                      password
                    }
                  );
                  const user = firebase.auth().currentUser;
                  if (!user) {
                    throw new Error("User not found");
                  }
                  await user.getIdTokenResult(true);
                  setLoading(false);
                  history.replace("/");
                } catch (e) {
                  setLoading(false);
                  alert(e.message);
                }
              }}
            />
          )}
        </>
      )}
    </Container>
  );
};

export default LoginScreen;
